import type { TGetClientContactsRes } from 'api/swagger';

export const findContactsById = (
  id?: number,
  contacts?: TGetClientContactsRes[],
): TGetClientContactsRes | undefined => {
  if (!contacts || !id) return undefined;

  return contacts?.find((contact) => contact.id === id);
};
